const isForecastMember = (entitlements: Array<string> | undefined) => {
  if (entitlements && entitlements.length) {
    return entitlements.includes('sl_forecast_only');
  }
  return false;
};

export default isForecastMember;
